import React, { useContext } from "react";
import { NavLink, Route } from "react-router-dom";
// import Cookies from 'js-cookie';
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import { Button, WindmillContext } from "@windmill/react-ui";
import { IoLogOutOutline } from "react-icons/io5";
import logoDark from "../../assets/img/logo/logo-dark.svg";
import logoLight from "../../assets/img/logo/logo-light.svg";
import language from "../../../language";
import sidebar from "../../routes/sidebar";
import './SideBaar.css'

import { AdminContext } from "../../context/AdminContext";
import { useHistory } from 'react-router-dom';

const SidebarContent = () => {
  const cookies = new Cookies();
  const history = useHistory();
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
      !sessionStorage.getItem("language")
      ? true
      : false;
  const isLogin = cookies.get("auth");
  const { mode } = useContext(WindmillContext);
  const { dispatch } = useContext(AdminContext);

  const handleLogOut = () => {
    Swal.fire({
      icon: "warning",
      title: "",
      text: "Do you really want to Sign-out ?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear cookies
        var allCookies = document.cookie.split(";");
        for (var i = 0; i < allCookies.length; i++) {
          document.cookie =
            allCookies[i].split("=")[0] + "=;expires=" + new Date(0).toUTCString();
        }

        // Clear local storage if needed
        // localStorage.clear();

        // Clear any other state or perform logout actions here
        // dispatch({ type: 'USER_LOGOUT' });

        // Redirect to login page without reloading
        history.push("/admin/login");
      }
    });
  };

  return (
    <div className="py-4 text-gray-500 sidebarContent">
      <div className=" text-gray-900" style={{ textDecoration: "underline" }}>
        <h1 style={{ marginLeft: "1.5rem", fontSize: "1.3rem" }}>
          {languageSelectedEnglish ? "Admin's Panel" : language.adminPanel}
        </h1>
      </div>
      <ul className="mt-8 tabsList">
        {sidebar.map((route) => (
          <li className="relative" key={route.name}>
            <NavLink
              exact
              to={route.path}
              className="px-6  sidebarLinkPad inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-green-700"
              activeClassName="text-green-500"
            >
              <Route path={route.path} exact={route.exact}>
                <span
                  className="absolute inset-y-0 left-0 w-1 bg-green-500 rounded-tr-lg rounded-br-lg addBusBtnHomeIndi"
                  aria-hidden="true"
                ></span>
              </Route>
              <route.icon className="w-5 h-5" aria-hidden="true" />
              <span className="ml-4">{route.name}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <span className="lg:fixed bottom-0 px-6 py-6 w-64 mx-auto relative mt-3 block">
        <button
          onClick={handleLogOut}
          size="large"
          className="w-full addBusBtnHome logOutBtnSideBar"
        >
          <span className="flex items-center blackOuter">
            <IoLogOutOutline
              className="mr-3 text-lg blackColor"
            />
            <span className="text-sm">
              {languageSelectedEnglish ? "Log out" : language.logout}
            </span>
          </span>
        </button>
      </span>
    </div>
  );
};

export default SidebarContent;
